var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.7778 7.55556c0 .94299-.3746 1.84736-1.0414 2.51414-.6668.6668-1.5712 1.0414-2.5142 1.0414s-1.8473-.3746-2.51414-1.0414c-.66679-.66678-1.04139-1.57115-1.04139-2.51414 0-.943.3746-1.84737 1.04139-2.51416.66684-.6668 1.57114-1.0414 2.51414-1.0414s1.8474.3746 2.5142 1.0414c.6668.66679 1.0414 1.57116 1.0414 2.51416zm-3.5556 6.22224c-1.6502 0-3.23286.6555-4.39975 1.8224-1.1669 1.1669-1.82245 2.7496-1.82245 4.3998h12.4444c0-1.6502-.6555-3.2329-1.8224-4.3998s-2.7495-1.8224-4.3998-1.8224z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.44b61f2a765f5452291f3d07c407a70d.svg";
export { ForwardRef as ReactComponent };